import StatusIndicator from 'components/StatusIndicator';
import useStyles from 'features/Health/components/FrameHealthChart/components/FrameHealthTooltip/FrameHealthTooltip.styles';
import { FrameHealthStatus } from 'features/Health/components/FrameHealthChart/types/frameHealthStatus';
import { addSpacesToCamelCase } from 'utils/addSpacesToCamelCase';

type FrameHealthTooltipProps = {
  frameHealthStatus: FrameHealthStatus;
  frameHealthDimension: string;
};

export const FrameHealthTooltip = ({
  frameHealthStatus,
  frameHealthDimension,
}: FrameHealthTooltipProps) => {
  const classes = useStyles();

  // Using Typography or Link will break the page and tooltip
  // as renderToString can't handle the translation
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <StatusIndicator color={frameHealthStatus.color} size="16px" />
        <div className={classes.title}>{`{name}: {valueXTotalPercent}%`}</div>
      </div>
      <div className={classes.subTitle}>Frames</div>
      <div className={classes.valueX}>{'{valueX}'}</div>
      <div className={classes.subTitle} style={{ textTransform: 'capitalize' }}>
        {addSpacesToCamelCase(frameHealthDimension)}
      </div>
      <div className={classes.categoryY}>{'{categoryY}'}</div>
    </div>
  );
};

export default FrameHealthTooltip;
